import Controller from '@ember/controller';

export default class MarketRevpakExportsController extends Controller {
  get iframeQPs() {
    return { iframe: 1, origin: window.location.origin };
  }
}
